import ex12Img from '../assets/models/ex12.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

export const experience12: PreQuerySizeGuideData = {
  fitIndicator: {
    value: 8,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    female: {
      imageUrl: ex12Img.src,
      modelSize: '',
      modelMeasurements: [],
    },
  },
};
